module.exports = __webpack_public_path__ + "frontend/images/pattern/pricing/white@2.jpg?01c4dc55a71195f3dd620888fc20f584";